import { EntityTablePagePartialProps } from "@crispico/foundation-react";
import { ReduxReusableComponents, RRCProps } from "@crispico/foundation-react/reduxReusableComponents/ReduxReusableComponents";
import { EquipmentResourceTablePage } from "pages/EquipmentResource/equipmentResourceEntityDescriptor";
import { HumanResourceScheduleTablePage, HumanResourceScheduleTablePageOptions, HumanResourceScheduleTablePageReducers, HumanResourceScheduleTablePageState } from "pages/HumanResourceSchedule/HumanResourceScheduleEntityDescriptor";
import { EntityTableSimpleDnDCellProps, EntityTableSimpleDnDCellRRC } from "./EntityTableSimpleDnDCell";
import { EntityTablePageWithGanttState } from "./EntityTablePageWithGantt";
import { XopsGanttPartialProps } from "./EntityTablePageWithGantt";
import { Mission } from "../../../../types";
import { RealTimeEmbeddedTableMixin } from "./RealTimeEmbeddedTableBase";
import { MenuActionId } from "@crispico/foundation-react";

const BaseClass = RealTimeEmbeddedTableMixin(HumanResourceScheduleTablePage);

export class RealTimeHumanResourceScheduleEmbeddedTableState extends HumanResourceScheduleTablePageState {
    protected static readonly defaultOptions: HumanResourceScheduleTablePageOptions = {
        ...EntityTablePageWithGanttState.defaultOptions,
        hideFinishedSchedules: true,
        showGantt: true,
        compactMode: true,
    };
    protected static readonly localStorageKey: string = 'RealTimeHumanResourceScheduleEmbeddedTable.options';
}
export class RealTimeHumanResourceScheduleEmbeddedTableReducers<S extends RealTimeHumanResourceScheduleEmbeddedTableState = RealTimeHumanResourceScheduleEmbeddedTableState> extends HumanResourceScheduleTablePageReducers<S> {
}

export type RealTimeHumanResourceScheduleEmbeddedTableProps = { getFullEntity?: (entityName: string, entity: any) => any; onRefresh?: () => Promise<void> } & EntityTablePagePartialProps & RRCProps<RealTimeHumanResourceScheduleEmbeddedTableState, RealTimeHumanResourceScheduleEmbeddedTableReducers>;

export class RealTimeHumanResourceScheduleEmbeddedTable extends BaseClass<RealTimeHumanResourceScheduleEmbeddedTableProps> {

    static defaultProps = {
        ...EquipmentResourceTablePage.defaultProps,
        embeddedMode: true,
    }

    constructor(props: RealTimeHumanResourceScheduleEmbeddedTableProps) {
        super(props);
        this.tableSimpleClass = EntityTableSimpleDnDCellRRC as any;
    }

    protected showInMenu(key: MenuActionId) {
        return true;
    }

    setDate(date: string | null) {
        this.props.r.setInReduxState({ options: { ...this.props.s.options, date: date } });
    }

    async superRefresh() {
        console.log("refresh hrs");
        return super.refresh();
    }

    async refresh() {
        if (this.props.onRefresh) {
            await this.props.onRefresh();
        } else {
            await this.superRefresh();
        }
    }

    protected async postRefreshHook(freshEntities: any[]): Promise<void> {
        await this.loadMissions(freshEntities);
    }

    getMission(missionId: any): Mission | undefined {
        const missionsByHrId: { [hrId: number]: Mission[] } = this.props.s.missionsByHrId;
        if (!missionsByHrId) {
            return undefined;
        }
        for (const hrId in missionsByHrId) {
            const missions = missionsByHrId[hrId];
            const mission = missions.find((m: Mission) => m.id === missionId);
            if (mission) {
                return mission;
            }
        }
        return undefined;
    }

    protected getTableSimpleProps(): Partial<EntityTableSimpleDnDCellProps> | undefined {
        return {
            ...super.getTableSimpleProps(),
            onDrop: this.xopsGanttRef.current?.onDrop
        };
    }

    protected getXopsGanttProps(): XopsGanttPartialProps {
        return {
            ...super.getXopsGanttProps(),
            activatedDnD: true
        }
    }

    render() {
        return super.renderMain();
    }
}

export const RealTimeHumanResourceScheduleEmbeddedTableRRC = ReduxReusableComponents.connectRRC(RealTimeHumanResourceScheduleEmbeddedTableState, RealTimeHumanResourceScheduleEmbeddedTableReducers, RealTimeHumanResourceScheduleEmbeddedTable);
